<template>
  <b-row class="m-5">
    <b-col>
      <b-overlay :show="submitting">
        <template v-slot:overlay>
          <div class="text-center">
            <b-icon-stopwatch
              font-scale="3"
              animation="cylon"
            ></b-icon-stopwatch>
            <p id="cancel-label">Saving, please wait...</p>
          </div>
        </template>

        <b-form>
          <b-container fluid>
            <b-row>
              <b-col>
                <span class="display-title">{{ selectedAccount.name }}</span>
              </b-col>
            </b-row>
            <hr />
            <b-row class="ml-2 mt-2 mb-2">
              <b-col>
                <b-button variant="blue" @click="reset">
                  <b-icon-arrow-left /> Back to accounts
                </b-button>
              </b-col>
              <b-col class="d-flex mr-2 justify-content-end">
                <b-button
                  variant="blue"
                  @click="editDetails = !editDetails"
                  v-if="selectedAccount.id"
                >
                  <b-icon-pencil /> Edit Account Name
                </b-button>
              </b-col>
            </b-row>
            <hr />
            <!-- Account detail edit -->
            <b-row v-if="editDetails">
              <b-col>
                <b-form-group :invalid-feedback="validationStat.name.msg">
                  <label for="name">
                    Name:
                  </label>
                  <b-input
                    type="text"
                    v-model="selectedAccount.name"
                    :maxlength="255"
                    required
                    @blur="onBlur($event.target)"
                    style="max-width:400px;"
                    ref="name"
                    id="name"
                  />
                </b-form-group>
                <b-form-group :invalid-feedback="validationStat.number.msg">
                  <label for="number">
                    Account Number:
                  </label>
                  <b-input
                    type="text"
                    v-model="selectedAccount.number"
                    :maxlength="255"
                    required
                    @blur="onBlur($event.target)"
                    style="max-width:400px;"
                    ref="number"
                    id="number"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <h5 v-if="!showSiteEditor">Locations</h5>
            <b-row>
              <b-col v-if="!showSiteEditor">
                <b-container fluid class="d-flex justify-content-start mb-3">
                  <b-row>
                    <b-col>
                      <b-button @click="onAddSite" variant="blue">
                        <b-icon-plus /> Add a New Site
                      </b-button>
                    </b-col>
                  </b-row>
                </b-container>

                <dx-data-grid
                  :data-source="sites ? sites : []"
                  :columns="sitesGrid.columns"
                  :selection="config.selection"
                  :onRowDblClick="onSiteSelection"
                >
                </dx-data-grid>
                <hr />
                <!-- Admins -->
                <b-row class="mb-3">
                  <b-col>
                    <h4>Administrators</h4>
                    <dx-data-grid :data-source="ca" :columns="caGrid.columns" />
                  </b-col>
                </b-row>

                <!-- Open Orders -->
                <b-row class="mb-3" v-if="!editDetails && selectedAccount.id">
                  <b-col>
                    <h4>Open Orders</h4>
                    <dx-data-grid
                      :data-source="orders"
                      :columns="ordersGrid.columns"
                      :onRowDblClick="openSelectedOrder"
                      :selection="config.selection"
                    />
                  </b-col>
                </b-row>
              </b-col>
              <b-col v-else>
                <site-editor @onClose="onEditorClose" />
              </b-col>
            </b-row>
            <hr />
            <b-row>
              <b-col>
                <b-row class="mt-5">
                  <b-col class="d-flex justify-content-end">
                    <b-button
                      class="action-button"
                      variant="blue"
                      @click="onSubmit"
                      type="submit"
                    >
                      Save
                    </b-button>
                  </b-col>
                  <b-col>
                    <b-button
                      class="action-button"
                      variant="orange"
                      @click="onClancel"
                    >
                      Cancel
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-container>
        </b-form>
      </b-overlay>
    </b-col>
  </b-row>
</template>

<script>
import { confirm } from "devextreme/ui/dialog";

import SiteEditor from "./SiteEdit";

export default {
  props: ["site"],
  components: {
    SiteEditor
  },
  data() {
    return {
      validationStat: {
        name: {
          msg: ""
        },
        number: {
          msg: ""
        }
      },
      ordersGrid: {
        columns: [
          {
            dataField: "number",
            caption: "Order #",
            sortOrder: "asc",
            width: 150
          },
          {
            dataField: "site_name",
            caption: "Site"
          },
          {
            dataField: "status",
            alignment: "center"
          },
          {
            dataField: "placed",
            caption: "Last Activity"
          }
        ]
      },
      sitesGrid: {
        columns: [
          {
            dataField: "name",
            sortOrder: "asc"
          },
          {
            caption: "Open Orders",
            alignment: "center",
            width: 100,
            calculateDisplayValue(e) {
              return e.orders.length;
            }
          },
          {
            caption: "Devices",
            alignment: "center",
            width: 100,
            calculateDisplayValue(e) {
              return e.devices.length;
            }
          }
        ]
      },
      caGrid: {
        columns: [
          {
            dataField: "name"
          },
          {
            caption: "Role",
            alignment: "center",
            width: 150,
            calculateDisplayValue(e) {
              return e.is_admin === 1 ? "Administrator" : "";
            }
          }
        ]
      },
      config: {
        selection: {
          mode: "single"
        }
      },
      showSiteEditor: false,
      editDetails: false,
      submitting: false
    };
  },
  beforeMount() {
    if (this.selectedAccount) {
      if (this.selectedAccount.sites) {
        this.selectedAccount.sites.forEach(s => {
          if (s.orders) {
            s.orders = s.orders.filter(
              o => o.status !== "Delivered" || o.status !== "Started"
            );
          }
        });

        this.editDetails = this.selectedAccount.id !== null;
      }
    }
  },
  //   beforeDestroy() {
  //     this.selectedAccount = null;
  //   },
  computed: {
    accounts() {
      return this.$store.getters["accounts/accounts"];
    },
    ca() {
      return this.$store.getters["accounts/caUsers"];
    },
    sites: {
      get() {
        var account = this.$store.getters["accounts/currentAccount"];
        if (!account) {
          return [];
        } else {
          return account.sites ? account.sites : [];
        }
      }
    },
    wasModified: {
      get() {
        return this.$store.getters["accounts/isDirty"];
      },
      set(val) {
        return this.$store.dispatch("accounts/flagChanges", val);
      }
    },
    sa() {
      return this.$store.getters["accounts/saUsers"];
    },
    selectedAccount: {
      get() {
        return this.$store.getters["accounts/currentAccount"];
      },
      set(val) {
        debugger;
        this.$store.dispatch("accounts/currentAccount", val);
      }
    },
    orders() {
      if (!this.$store) {
        return [];
      }
      debugger;
      var account = this.$store.getters["accounts/currentAccount"];

      if (!account) {
        return [];
      }

      var orders = [];

      account.sites.forEach(s => {
        s.orders.forEach(o => orders.push(o));
      });

      return orders;
    }
  },
  methods: {
    onBlur(e) {
      debugger;

      var isStr = typeof e.value === "string";
      if (isStr) {
        this.selectedAccount[e.id] = e.value.trim();
      }
    },
    onAddSite() {
      var site = {
        account_id: this.selectedAccount.id,
        name: "",
        address: "",
        city: "",
        state: "",
        postal_code: "",
        orders: [],
        devices: [],
        users: [],
        favorite_Items: [],
        site_memberships: []
      };

      this.$store.dispatch("accounts/currentSite", site).then(() => {
        this.showSiteEditor = true;
        // this.$router.push({ name: "edit" });
      });
    },
    onSiteSelection(e) {
      debugger;
      var site = e.data ? e.data : null;
      this.$store.dispatch("accounts/currentSite", site).then(() => {
        // this.showSiteEditor = true;

        if (!this.models || !this.items) {
          return this.$store.dispatch("sysEquipment/getModels").then(() => {
            if (
              !this.$store.getters["sysItems/items"] ||
              this.$store.getters["sysItems/items"].length === 0
            ) {
              return this.$store
                .dispatch("sysItems/getItems")
                .then(() => this.$store.dispatch("accounts/getSaUsers"))
                .then(() => (this.showSiteEditor = true));
            } else {
              return this.$store
                .dispatch("accounts/getSaUsers")
                .then(() => (this.showSiteEditor = true));
            }
          });
        } else if (this.models.length === 0 || this.items.length === 0) {
          return this.$store.dispatch("sysEquipment/getModels").then(() => {
            debugger;
            if (
              !this.$store.getters["sysItems/items"] ||
              this.$store.getters["sysItems/items"].length === 0
            ) {
              return this.$store
                .dispatch("sysItems/getItems")
                .then(() => this.$store.dispatch("accounts/getSaUsers"))
                .then(() => (this.showSiteEditor = true));
            } else {
              return this.$store
                .dispatch("accounts/getSaUsers")
                .then(() => (this.showSiteEditor = true));
            }
          });
        }
      });
    },
    onSubmit(e) {
      e.preventDefault();
      debugger;
      this.submitting = true;
      var site = this.$store.getters["accounts/currentSite"];

      //Items that where added during edit but then deleted,
      //since it's not in the database, we can remove them here:

      debugger;

      if (site) {
        //is this a new site?
        if (!site.id) {
          // add to list then submit update.
          this.selectedAccount.sites.push(site);
        }
        if (site.favorite_Items) {
          var deletedItems = site.favorite_Items.filter(i => i.delete && !i.id);
          if (deletedItems.length > 0) {
            deletedItems.forEach(i => delete site.favorite_Items[i]);
          }
        }
      }

      if (!this.selectedAccount.id) {
        return this.$store.dispatch("accounts/addAccount").then(rsp => {
          debugger;
          if (rsp) {
            this.reset();
          } else {
            this.submitting = false;
            return;
          }
        });
      } else {
        return this.$store.dispatch("accounts/updateAccount").then(rsp => {
          if (rsp) {
            this.reset();
            return;
          } else {
            this.submitting = false;
            return;
          }
        });
      }
    },
    reset() {
      debugger;
      // var me = this;
      debugger;
      this.$store.dispatch("accounts/getAccounts").then(() => {
        this.submitting = false;
        this.showSiteEditor = false;
        this.wasModified = false;
        this.selectedAccount = null;
        window.location = "#/admin/accounts";
        return;
      });
      // .then(() => (me.showSiteEditor = false))
      // .then(() => (me.wasModified = false))
      // .then(() => (me.selectedAccount = null))
      // .then(() => (window.location = "#/admin/accounts"));
    },
    onEditorClose(e) {
      this.showSiteEditor = e;
    },
    onClancel() {
      debugger;
      if (this.wasModified) {
        var msgBox = confirm(
          "<p>It appears that this may be a new account or made changes to it <br/> Are you sure you want to cancel these changes?</p>",
          "Confirmation"
        ).then(rsp => {
          debugger;

          if (rsp) {
            return this.reset();
            // return this.$store
            //   .dispatch("accounts/getAccounts")
            //   .then(() => (this.wasModified = false))
            //   .then(() => (this.selectedAccount = null));
          } else {
            return;
          }
        });
      } else {
        this.reset();
      }
    },
    openSelectedOrder(e) {
      debugger;

      this.$router.push({ name: "order", params: { ord: e.data } });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/AccountEdit.vue